/**
 * Values for laboratory option "ConstantDryMassEntry"
 *
 * Never - Only one dry mass reading can be recorded and is assumed to be dry. Drying time is not recorded.
 * Optional - By default, tests will have one dry mass reading. Technicians can choose to record further dry mass readings. Drying time is recorded.
 * Always - By default, tests will have two dry mass readings. Technicians can choose to remove the second reading or record further dry mass readings. Drying time is recorded.
 */
export type ConstantDryMassEntryOption = 'Never' | 'Optional' | 'Always';

/**
 * Values for moisture content field Preparation.GrainSize
 */
export enum GrainSize {
  Coarse = 'Coarse',
  Medium = 'Medium',
  Fine = 'Fine',
}

export enum MethodType {
  BS_EN_ISO = 'BS EN ISO 17892-1',
  BS_1377_2 = 'BS 1377-2 Clause 4.1',
}
